import React, { useState, useContext } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { modalCloseHandler, modalCloseNextModalHandler } from '../Modal/utils';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import styles from './styles.css';

const AppModal = () => {
  const { next, appState, closeNextModal, formProps } = useContext(FlowContext);
  const investAmount = appState.store.amount;

  const [meetsAppInvAmount, setMeetsAppInvAmount] = useState(false);

  const handleAppInvAmount = ({ target: { value } }) => {
    const val = Number(value);
    if (val >= 50000) {
      setMeetsAppInvAmount(true);
    } else {
      setMeetsAppInvAmount(false);
    }
  };

  return (
    <>
      <MFBeaconModal open removeCloseButton>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            variant="tertiary"
            role="button"
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            data-name={generateGeneralTestID('AppModal', 'CloseButton')}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">
          Increase your investment amount to meet the required minimum
        </div>
        <div className="beacon-modal__description">
          <b>The T. Rowe Price</b> ActivePlus Portfolios<sup>&reg;</sup> program
          require a minimum investment of $50,000. Please adjust your investment
          amount or choose another option. (The minimum amount for other
          investment options is $1,000.)
        </div>
        <InputField
          type="text"
          inputMode="numeric"
          title="I want to contribute $"
          {...formProps.amount}
          defaultValue={investAmount}
          onChange={handleAppInvAmount}
          data-name={generateGeneralTestID('AppModal', 'AppInvestmentAmount')}
        />
        <div className="app-modal-btn-container" slot="action-zone">
          <MFBeaconButton
            variant="tertiary"
            role="button"
            id="activePlusMinimumModalClose"
            type="button"
            noButtonMargin
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            label="Cancel"
            data-name={generateGeneralTestID('AppModal', 'CancelButton')}
          />
          <MFBeaconButton
            variant="primary"
            id="activePlusMinimumModalContinue"
            role="button"
            data-name={generateGeneralTestID('AppModal', 'ContinueButton')}
            className="modal-continue-btn"
            type="button"
            noButtonMargin
            onClick={
              meetsAppInvAmount
                ? () => {
                    modalCloseHandler();
                    next('app')();
                  }
                : next('skipCloseNextModal')
            }
            label="Continue"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default AppModal;
